<template>
	<div>
		<swiper :options="swiperOption" class="swiper" v-if="list.length>0">
			<swiper-slide class="swiper-item" v-for="(item,index) in list" :key="index">
				<video @click="toUrl(item.url)" :class="{'icon-on':item.url}"
					style="width: 100%;height: 100%;object-fit: cover;" autoplay muted loop
					v-if="checkMediaType(item.cover) == 'video'" :src="item.cover"></video>
				<img @click="toUrl(item.url)" class="img" :class="{'icon-on':item.url}"
					style="width: 100%;height: 100%;" :src="item.cover" alt=""
					v-if="checkMediaType(item.cover) == 'image'" />
			</swiper-slide>
			<div class="swiper-pagination"></div>
			<img src="@/assets/xiayizhang.png" class="lbt-arrow lbt-arrow-left" alt="" />
			<img src="@/assets/xiayizhang.png" class="lbt-arrow lbt-arrow-right" alt="" />
		</swiper>
		<img class="bg" src="@/assets/bg.png" alt="" v-else>
	</div>
</template>

<script>
	export default {
		name: 'swiper-box',
		props: {
			list: {
				type: Array,
				default: () => []
			},
		},
		data() {
			return {
				swiperOption: {
					pagination: {
						el: '.swiper-pagination',
						clickable: true,
					},
					loop: true,
					autoplay: true,
					autoplayDisableOnInteraction: false,
					autoplayStopOnLast: false,
					effect: 'fade',
					navigation: {
						nextEl: '.lbt-arrow-right', //前进按钮的css选择器或HTML元素。
						prevEl: '.lbt-arrow-left', //后退按钮的css选择器或HTML元素。
					},
				},
			}
		},
		methods: {
			toUrl(url) {
				if (url) {
					window.open(url)
				}
			},
			checkMediaType(url) {
				// 创建URL对象
				var link = new URL(url);

				// 获取路径部分（去除参数）
				var path = link.pathname;

				// 获取路径的最后一个点之后的内容作为文件扩展名
				var extension = path.split('.').pop().toLowerCase();

				// 声明支持的图片和视频文件扩展名
				var imageExtensions = ['jpg', 'jpeg', 'gif', 'png'];
				var videoExtensions = ['mp4', 'wmv', 'avi', 'mov'];

				// 判断文件扩展名是否在图片扩展名数组中
				if (imageExtensions.includes(extension)) {
					return 'image';
				}

				// 判断文件扩展名是否在视频扩展名数组中
				if (videoExtensions.includes(extension)) {
					return 'video';
				}

				// 扩展名不在图片或视频数组中，返回null表示无法确定媒体类型
				return null;
			}
		}
	}
</script>
<style lang="scss" scoped>
	@media screen and (min-width: 1000px) {
		::v-deep.swiper .swiper-pagination-bullet {
			width: 8px;
			height: 8px;
			background: #fff;
			opacity: .5;
			transition: .2s;
			margin: 0 4px;
		}
		
		::v-deep.swiper .swiper-pagination-bullet-active {
			background: #fff;
			width: 15px;
			border-radius: 8px;
			opacity: 1;
		}
	    .bg {
	    	width: 100%;
	    	height: 300px;
			object-fit: cover;
	    }
		.swiper {
			width: 100%;
			position: relative;
			height: calc(100vw / (1280 / 300));
			.swiper-item {
				background-color: #f8f8f8;
				.img {
					transition: transform 0.5s ease;
					transform-origin: center;
					object-fit: cover;
				}
		
				.img:hover {
					transform: scale(1.02);
				}
			}
		
			.swiper-pagination {
				position: absolute;
				width: 100%;
				bottom: 10px;
				left: 50%;
				transform: translateX(-50%);
			}
		
			.lbt-arrow {
				position: absolute;
				top: 50%;
				cursor: pointer;
				width: 40px;
				height: 60px;
				opacity: 0;
				display: flex;
				justify-content: center;
				align-items: center;
				visibility: hidden;
				transition: all 0.3s ease-in-out;
				z-index: 9;
			}
		
			.lbt-arrow-left {
				transform: translateY(-50%) rotate(180deg);
				left: 120px;
			}
		
			.lbt-arrow-right {
				transform: translateY(-50%);
				right: 120px;
			}
		
			.icon-on {
				cursor: pointer;
			}
		}
		.swiper:hover .lbt-arrow {
			visibility: visible;
			opacity: 1;
		}
	}
	@media screen and (max-width: 999px){
		::v-deep.swiper .swiper-pagination-bullet {
			width: 2.13339vw;
			height: 2.13339vw;
			background: #fff;
			opacity: .5;
			transition: .2s;
			margin: 0 1.3333339vw;
		}
		
		::v-deep.swiper .swiper-pagination-bullet-active {
			background: #fff;
			width: 4vw;
			border-radius: 4vw;
			opacity: 1;
		}
		.bg {
			width: 100%;
			height: 40vw;
			object-fit: cover;
		}
		.swiper{
			width: 100%;
			height: 48vw;
			position: relative;
			.swiper-item {
				background-color: #f8f8f8;
				.img {
					object-fit: cover;
				}
			}
			.swiper-pagination {
				position: absolute;
				width: 100%;
				bottom: 10px;
				left: 50%;
				transform: translateX(-50%);
			}
		}
	}
	
</style>